export default __webpack_public_path__ + "static/media/logo.33c729d6.png";